import { AppBar, FormControlLabel, Switch, makeStyles, styled, withStyles } from "@material-ui/core";
import { useIO, useModel } from "@type-r/react";
import { Button, Flex, Loading, Page, PrimaryButton, SelectSortBy, Toolbar, navigate } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { RowH1 } from "../../../../../common";
import { Connection } from "../api/connection";
import { AddFilter } from "../components/search-bar/search-bar";
import { ConnectionsList } from "./connections-list";
import { SortingTemplate } from "./models/connections-filter";
import { ConnectionsStore } from "./models/connections-store";

export const ConnectionsPage = () => {
    const classes = useStyles();
    const state = useModel(ConnectionsStore);
    const [connections, setConnections] = React.useState<Connection[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const isReady = useIO(async () => {
        await Promise.all([
            await state.flowTypes.fetch(),
            await state.channelTypes.fetch(),
        ])
        await fetchConnections();
        state.initialize()
        setConnections(state.connections.items.models);
    }, [])

    const dataLoaded = useIO(async () => {
        if (isReady) {
            await fetchConnections();
            setConnections(state.connections.items.models);
        }
    }, [state.connectionsFilter["_changeToken"], state.isActive])

    const fetchConnections = async (skip = 0, take = 100) => {
        setIsLoading(true);
        await state.getFiltered(state.mapToQuery(skip, take))
            .then((connections) => {
                state.connections.set(connections);
            });
        setIsLoading(false);
    }

    const scrollEvent = async ({ target }) => {
        const isBottom = target.scrollHeight - target.offsetHeight - target.scrollTop <= 1 && target.scrollHeight / target.offsetHeight > 2.1;
        if (isBottom && !isLoading && state.connections.items.models.length === 100) {
            await fetchConnections(connections.length, 100);
            setConnections(prev => [...prev, ...state.connections.items.models]);
        }
    }

    return <>
        <Page maxWidth={false} header={
            <Flex center>
                <RowH1 className={classes.title}>Connections</RowH1>
            </Flex>
        }
            top={
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <StyledFilterBar filter={state.connectionsFilter} filterAllPlaceholder="Filter by Company Name, Connection Name, Channel, etc." selectedFilterBy={state.selectedFilterBy} />
                        <StyledFormControlLabel
                            control={
                                <Switch
                                    onChange={(e, c) => state.isActive = c}
                                    color="primary"
                                />
                            }
                            label={"Active"}
                            labelPlacement="start"
                        />
                        <SelectSortBy $attr={state.connectionsFilter.sortBy.$.attr} $asc={state.connectionsFilter.sortBy.$.asc} options={SortingTemplate} />
                        {Can(UserEntitlementCatalogs.ViewCreateNewConnectionsButton) &&
                            <PrimaryButton
                                style={{ marginLeft: "auto" }}
                                onClick={() => navigate("connections/new")}>
                                Create Connection
                            </PrimaryButton>
                        }
                    </Toolbar>
                </AppBar>
            }>
            {isReady && dataLoaded ? <ConnectionsList connections={connections} scrollPagination={scrollEvent} ></ConnectionsList> : <Loading />}
        </Page>
    </>
};

const useStyles = makeStyles({
    title: {
        padding: '20px 0',
        color: '#3d6889',
        fontSize: '24px'
    }
});

const StyledFilterBar = styled(AddFilter)({
    width: '650px',
    alignItems: 'center',
    padding: '4px',
})

const StyledFormControlLabel = withStyles({
    label: {
        fontSize: '13px',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: 'grey',
    },
    labelPlacementStart: {
        margin: '0 !important'
    }
})(FormControlLabel)
